import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import {
  exportPrePickingShortageReportToExcel,
  exportPrePickingShortageReportToPdf,
} from "helpers/prePicking";
import {
  PrePickingClientInfo,
  PrePickingShortageRow,
  PrePickingSummary,
} from "types";

type Props = {
  client: PrePickingClientInfo;
  summary: PrePickingSummary;
  report: PrePickingShortageRow[];
};

export default function PrePickingReport({ client, summary, report }: Props) {
  return (
    <Paper sx={{ p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        flexDirection={{ xs: "column", md: "row" }}
        gap={2}
        mb={2}
      >
        <Box>
          <Typography variant="h6" fontWeight="bold">
            Reporte de faltantes
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Cliente: {client.code} - {client.razon_social}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Filas validadas: {summary.validated_rows} | Filas con faltante:{" "}
            {summary.shortage_rows}
          </Typography>
        </Box>

        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            onClick={() => exportPrePickingShortageReportToExcel(client, report)}
          >
            Exportar Excel
          </Button>
          <Button
            variant="outlined"
            onClick={() => exportPrePickingShortageReportToPdf(client, report)}
          >
            Exportar PDF
          </Button>
        </Box>
      </Box>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Codigo</TableCell>
              <TableCell>Descripcion</TableCell>
              <TableCell align="right">Solicitado</TableCell>
              <TableCell align="right">Existencia</TableCell>
              <TableCell align="right">Diferencia</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {report.map((row, index) => (
              <TableRow key={`${row.codigo}-${row.row_number}-${index}`}>
                <TableCell>{row.codigo}</TableCell>
                <TableCell>{row.descripcion}</TableCell>
                <TableCell align="right">{row.solicitado}</TableCell>
                <TableCell align="right">{row.existencia}</TableCell>
                <TableCell align="right">{row.diferencia}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
